import Axios from "axios";
import { getItemInLocalStorage } from "./localStorage";
import { getValidToken } from "./authService";
const BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = process.env.REACT_APP_INFINI_API_URL;

const api = Axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  async (config) => {
    const token = await getValidToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for global error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorResponse = error.response;
    // Handle Bad Request (400) errors
    if (errorResponse && errorResponse.status === 400 && errorResponse.data?.message?.includes("Bad request, user not found")) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(errorResponse);
  }
);

/**
 * @description This call is prior checking the user while login, before sending the OTP to check the user is already registered or not, this does not require any token
 */
export const postCallForGetUser = <T>(url: string, payload: T) => {
  return Axios.post(BASE_URL + url, payload, {})
    .then((response) => response)
    .catch((error) => {
      return error.response;
    });
};

export const postCall = <T>(url: string, payload: T) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .post(BASE_URL + url, payload, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const putCall = <T>(url: string, payload: T) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .put(BASE_URL + url, payload, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const getCall = (url: string) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .get(BASE_URL + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const deleteCall = <T>(url: string, payload?: T) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .delete(BASE_URL + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
      data: payload, // Include the payload in the data property
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      console.error("Error in deleteCall:", error);
      return error.response;
    });
};

export const getCallForFaceLogin = (url: string) => {
  return Axios.get(BASE_URL + url, {})
    .then((response) => response)
    .catch((error) => {
      console.log(error);
      return error.response;
    });
};

/**
 * @description Function to sign out the user once the session expires
 */
const signOut = () => {
  alert("Session expired. Please login again.");
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
};

/**
 * @description This call is to get user details this does not require any token
 */
export const getCallWithoutAuth = (url: string) => {
  return Axios.get(BASE_URL + url)
    .then((response) => response)
    .catch((error) => {
      console.log(error, "error");
      return error.response;
    });
};

export const getCallHDBWithoutAuth = (url: string) => {

return Axios.get(API_URL + url)
    .then((response) => response)
    .catch((error) => {
      console.log(error, "error");
      return error.response;
    });
  }

  export const getCallHDB = (url: string) => {
  const userId = getItemInLocalStorage("localId");
  return api
    .get(API_URL + url, {
      headers: {
        Authorization: `Bearer ${getItemInLocalStorage("idToken")}`,
        userid: typeof userId === "number" ? `'${userId}'` : userId,
      },
    })
    .then((response) => {
      if (response?.data?.message?.includes("User authorization has failed")) {
        signOut();
      }
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};